<template>
    <div class="cf-item cf-item-categories cf-item-categories-links active">
        <BaseCatalogCategoriesWidget :fetch="{level_to: category?.level ? (category?.level > 1 ? 3 : 2) : 1, mode: 'widget', start_position: category?.level > 2 ? category.parent_position_h : category.position_h, response_fields: ['id', 'code', 'title', 'url_without_domain']}" v-slot="{items}">
            <template v-if="items.length">
                <div v-if="category?.level && category.title" class="cf-title cf-item-categories-title">{{category?.level == 3 && category?.parents ? Object.values(category.parents).pop()?.title : category.title}}</div>
                <div v-else class="cf-title cf-item-categories-title"><BaseCmsLabel code="categories_title" /></div>
                <CatalogSidebarCategoriesItems :items="items" :category="category" />
            </template>
            <template v-else-if="category?.level == 2">
                <div v-if="category?.level && category.title" class="cf-title cf-item-categories-title">{{category?.parents ? Object.values(category.parents).pop()?.title : category.title}}</div>
                <BaseCatalogCategoriesWidget :fetch="{level_to: 2, mode: 'widget', start_position: category.parent_position_h, response_fields: ['id', 'code', 'title', 'url_without_domain']}" v-slot="{items}">
                    <CatalogSidebarCategoriesItems v-if="items.length" :items="items" :category="category" />
                </BaseCatalogCategoriesWidget>
            </template>                        
        </BaseCatalogCategoriesWidget>  
    </div>
</template>

<script setup>
    const props = defineProps(['category']);
</script>

